import React from "react";
import styled from "styled-components";
import { LeaderboardTableRowMobile } from "./LeaderboardTableRowMobile";

interface LeaderboardTableMobileProps {
  data: Array<object>;
  onRowClick?: (address: string) => void;
}

export const LeaderboardTableMobile = ({ data, onRowClick }: LeaderboardTableMobileProps) => {
  return (
    <LeaderboardTableContainerStyled>
      {data.map((el: any) => (
        <LeaderboardTableRowMobile el={el} onRowClick={onRowClick} />
      ))}
    </LeaderboardTableContainerStyled>
  );
};

const LeaderboardTableContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
